<template>
<div>
 <h1 class='n-title'>更新公告</h1>
     <iframe style="width:100%;border:none" src='static/html/release-notes.2.5.5.html' ></iframe>
    <div class="n-footer">
            <button @click="goHome()">进入系统</button>
        </div>
</div>
    <!--<div class="notice">
        <h1 class="n-title">更新公告</h1>
        <div class="n-content">
            <h2 class="n-title1">本次上线了以下内容:</h2>
            <p class="n-content1">-1.增加了常见问题和推荐设备的说明；</p>
            <p class="n-content1">-2.优化了训练介绍画面和结束画面的内容展示；</p>
            <p class="n-content1">-3.临时下架量表《进食评估问卷调查工具-10》，预计下个版本恢复；</p>
            <p class="n-content1">-4.优化了部分训练的名称，具体如下：</p>
            <div class="n-img">
                <table>
                    <tr>
                        <th>原名称</th>
                        <th>新名称</th>
                    </tr>
                    <tr>
                        <td>数字筛选-I</td>
                        <td>数字筛选</td>
                    </tr>
                    <tr>
                        <td>数字筛选-II</td>
                        <td>数字筛选•进阶</td>
                    </tr>
                    <tr>
                        <td>记忆犹新	</td>
                        <td>成双成对•进阶</td>
                    </tr>
                    <tr>
                        <td>藏猫猫棋-II	</td>
                        <td>萍踪浪迹 </td>
                    </tr>
                    <tr>
                        <td>举棋不定	</td>
                        <td>藏猫猫棋•进阶</td>
                    </tr>
                    <tr>
                        <td>举棋不定-II	</td>
                        <td>萍踪浪迹•进阶 </td>
                    </tr>
                    <tr>
                        <td>似曾相识-II	</td>
                        <td>似曾相识•进阶</td>
                    </tr>
                    <tr>
                        <td>似曾相识-III	</td>
                        <td>识物辨价</td>
                    </tr>
                    <tr>
                        <td>鱼翔浅底-反	</td>
                        <td>鱼翔浅底•进阶</td>
                    </tr>
                    <tr>
                        <td>梦想天空-反	</td>
                        <td>梦想天空•进阶</td>
                    </tr>
                    <tr>
                        <td>今天去哪	</td>
                        <td>路在何方</td>
                    </tr>
                    <tr>
                        <td>麻将求和	</td>
                        <td>麻将求和•进阶</td>
                    </tr>
                    <tr>
                        <td>麻将求和-II	</td>
                        <td>麻将求和</td>
                    </tr>
                    <tr>
                        <td>求和比较	</td>
                        <td>麻将比较•进阶</td>
                    </tr>
                    <tr>
                        <td>求和比较-II	</td>
                        <td>麻将比较</td>
                    </tr>
                    <tr>
                        <td>求和比较-III	</td>
                        <td>扑克比较</td>
                    </tr>
                    <tr>
                        <td>打地鼠-II</td>
                        <td>打怪物</td>
                    </tr>
                    <tr>
                        <td>注意记忆	</td>
                        <td>稍纵即逝</td>
                    </tr>
                    <tr>
                        <td>注意记忆-II	</td>
                        <td>稍纵即逝•进阶</td>
                    </tr>
                    <tr>
                        <td>目不暇接-I	</td>
                        <td>目不暇接</td>
                    </tr>
                    <tr>
                        <td>目不暇接-II	</td>
                        <td>目不暇接•进阶</td>
                    </tr>
                    <tr>
                        <td>找大圆	</td>
                        <td>明察秋毫</td>
                    </tr>
                    <tr>
                        <td>判断方向	</td>
                        <td>变幻方向</td>
                    </tr>
                    <tr>
                        <td>幻色图形-II	</td>
                        <td>幻色图字</td>
                    </tr>
                    <tr>
                        <td>幻色气球-II	</td>
                        <td>幻色气球</td>
                    </tr>
                    <tr>
                        <td>缤纷树叶-II	</td>
                        <td>缤纷树叶</td>
                    </tr>
                    <tr>
                        <td>变幻方向	</td>
                        <td>变幻方向•进阶</td>
                    </tr>
                    <tr>
                        <td>迎面而来-II	</td>
                        <td>鸟兽虫鱼</td>
                    </tr>
                    <tr>
                        <td>迎面而来-III	</td>
                        <td>果园飘香</td>
                    </tr>
                    <tr>
                        <td>迎面而来-IV	</td>
                        <td>工具速配</td>
                    </tr>
                    <tr>
                        <td>卡片队列-I	</td>
                        <td>卡片队列</td>
                    </tr>
                    <tr>
                        <td>卡片队列-II	</td>
                        <td>迎面而来•进阶</td>
                    </tr>
                    <tr>
                        <td>卡片队列-III	</td>
                        <td>鸟兽虫鱼•进阶</td>
                    </tr>
                    <tr>
                        <td>卡片队列-IV	</td>
                        <td>果园飘香•进阶</td>
                    </tr>
                    <tr>
                        <td>念念不忘	</td>
                        <td>按图索骥</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="n-footer">
            <button @click="goHome()">进入系统</button>
        </div>
    </div>-->
</template>

<script>
    export default ({
        data() {
            return {

            }
        },
        methods: {
            goHome(){
                this.$parent.$parent.toRefresh();
                this.$parent.$parent.dialog=false;
            }
        }
    })
</script>

<style scoped>
.notice{
    margin:0 30px;
}
.n-title{
    text-align:center;
}
.n-content{
    font-size:16px;
    overflow-y: scroll;
    margin-bottom:5px;
}
.n-footer{
    text-align: center;
    margin-top: 10px;
}
.n-footer button{
    background-color:#333;
}
.n-img,.n-img img{
    width:400px;
    max-height:200px;
}
.n-img table{
    border:1px solid #ccc;
    text-align:center;
    overflow: hidden;
}
table tr{
    border-bottom:1px solid #ccc;
}
table tr th,table tr td{
    border-right:1px solid #ccc;
}

@media (-webkit-max-width: 1280px) and (-webkit-min-width: 1024px),(max-width:1280px) and (min-width:1024px){
    .notice{
        width:600px;
        height:500px;
    }
    .n-title{
        margin-top:0px;
        font-size: 20px;
    }
    .n-title1{
        font-size: 18px;
    }
    .n-content1{
        font-size: 14px;
    }
    .n-img,.n-img img{
        background-size:100%; 
        width:272px;
        height: 110px;
    }
}
   
@media (-webkit-max-width: 1024px),(max-width:1024px){
    .notice{
        width:600px;
        height:500px;
    }
    .n-title{
        margin-top:0px;
        font-size: 20px;
    }
    .n-title1{
        margin:8px 0 8px 0;
        font-size: 16px;
    }
    .n-content1{
        font-size: 14px;
        overflow-y: scroll;
        margin-bottom:5px;
    }
    .n-img,.n-img img{
        width:272px;
        height: 110px;
    }
}


    

</style>



// WEBPACK FOOTER //
// notice.vue?8c531292